import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Provider } from 'react-redux';

import Modal from '../../../../components/Modal';
import useLogs from '../../../../hooks/FastCash/useLogs';
import store from '../../../../store';

import LogsTable from './components/LogsTable';

const FastCashLog = (props) => {
  const { onClose, fastCashId } = props;
  const { logs, loadLogs, logsLoadingState } = useLogs();

  useEffect(() => {
    loadLogs(fastCashId);
  }, []);

  return (
    <Modal title="Show Logs" onClose={onClose} isModalOpen={true}>
      <div>
        <LogsTable logs={logs} loadingState={logsLoadingState} />
        <div className="modal-actions">
          <button className="button -in-group" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

FastCashLog.propTypes = {
  onClose: PropTypes.func.isRequired,
  fastCashId: PropTypes.string.isRequired,
};

const addStore = (ProxyComponent) => (props) =>
  (
    <Provider store={store}>
      <ProxyComponent {...props} />
    </Provider>
  );

export default compose(addStore)(FastCashLog);
